import styled from '@emotion/styled'

import media from '../../../../styles/media'
import { colors } from '../../../../styles/theme'

const S = {}

S.MenuLogo = styled.div`
  path {
    fill: ${colors.orange};
    transition: fill 0.15s cubic-bezier(0, 0, 0.25, 1);
  }

  @media (hover: hover) {
    &:hover {
      path {
        fill: ${({ lightMode }) => !lightMode && colors.white};
      }
    }
  }

  .hidden-mobile {
    display: none;

    ${media.sm`
      display: block;
    `};
  }

  .hidden-tablet {
    display: block;

    ${media.sm`
      display: none;
    `};
  }
`

export default S
